"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormGridLayout = void 0;
const react_1 = __importDefault(require("react"));
const FormGridLayout = ({ children }) => react_1.default.createElement("div", { style: {
        width: '100%',
        display: 'grid',
        gap: '0.5rem',
        gridTemplateColumns: '1fr 1fr',
    } }, children);
exports.FormGridLayout = FormGridLayout;
